import React from "react";
import MapOfUS from "../../../MapOfUS";

import { useQueryParams } from "use-query-params";
import { FilterModel as mapQueryModel } from "../filterModel";

const MapSelector = ({ states, statesServiced }) => {
    const [mapQuery, setMapQuery] = useQueryParams(mapQueryModel);
    const selectedState = mapQuery?.stateId;
    const mapData = {};
    states.forEach((usaState) => {
        if (
            statesServiced.find((item) => item.stateId === usaState.stateCode)
        ) {
            mapData[usaState.stateCode] = {
                styles:
                    selectedState === usaState.stateCode
                        ? { fill: "var(--bs-secondary)" }
                        : { fill: "var(--bs-primary)" },
                hoverStyles:
                    selectedState === usaState.stateCode
                        ? { fill: "var(--bs-secondary)" }
                        : { fill: "var(--bs-primary-dark)" },
                href: usaState.valueLink,
                clickHandler: () => {
                    setMapQuery({
                        stateId:
                            selectedState === usaState.stateCode
                                ? undefined
                                : usaState.stateCode,
                        nicheItemId: undefined,
                    });
                },
            };
        } else {
            mapData[usaState.stateCode] = {
                styles: { fill: "var(--bs-gray-400)" },
                hoverStyles: { fill: "var(--bs-gray-500)" },
                isExcluded: true,
            };
        }
    });

    return (
        <div data-test="map-state-select">
            <MapOfUS className="mb-4" showToolTip={false} mapData={mapData} />
        </div>
    );
};

export default MapSelector;
